import * as d3 from 'd3'

export const draw_x_axis_label = (instance, { width, height, x_axis }) => {
    instance.append('text')
        .attr('text-anchor', 'middle')
        .attr('x', width/2)
        .attr('y', height + x_axis.label_distance)
        .text(x_axis.label);
}

export const get_scale_time = ({ width, start_time_str, end_time_str }) => {
    const time_parse = d3.timeParse('%Y-%m-%d %H:%M:%S')
    const start_datetime = time_parse(start_time_str)
    const end_datetime = time_parse(end_time_str)
    return d3.scaleTime()
        .domain([start_datetime, end_datetime])
        .range([0, width])
}

export const draw_x_axis_time_tick = (instance, { height, margin, scale_time, x_axis }) => {
    instance.append('g')
        .attr('class', 'X_AXIS')
        .attr('transform', `translate(${margin.left}, ${height})`)
        .call(d3.axisBottom(scale_time)
            .tickFormat((d, i) => i % x_axis.display_interval === 1 ? d3.timeFormat('%H:%M')(d) : '')
            .tickSize(10)
            .ticks(x_axis.ticks)
        )
    
    d3.selectAll("g.X_AXIS g.tick line")
        .attr("y2", (d, i) => i % x_axis.display_interval === 1 ? 10 : 7);
}

export const draw_day_line = (instance, { height, margin, scale_time }) => {
    // 換日線
    instance.append('g')
        .attr('transform', `translate(${margin.left}, ${height})`)
        .attr('class', 'date_line')
        .call(d3.axisTop(scale_time)
            .tickSize(height)
            .tickPadding(16)
            .tickFormat(d => d3.timeFormat('%Y-%m-%d')(d))
            .ticks(d3.timeHour.every(24))
        )
}